import Vue from 'vue';
import Router from 'vue-router';

// Component Views
import WizardStart from './views/Wizard.Start.vue';
import WizardRoot from './views/Wizard.Root.vue';
import WizardResidential from './views/Wizard.Residential';

Vue.use(Router);

// https://router.vuejs.org/api

export default new Router({
  mode: 'history', // "hash" | "history" | "abstract"
  base: process.env.BASE_URL,
  linkActiveClass: 'active',

  scrollBehavior(to, from, savedPosition) {
    if (to.name === from.name) {
      return savedPosition;
    }

    if (to.hash) {
      return {
        selector: to.hash
        // , offset: { x: 0, y: 10 }
      };
    }

    return {
      x: 0,
      y: 0,
    };
  },

  routes: [
    {
      alias: '/',
      path: '/wizard',
      component: WizardRoot,
      children: [
        {
          path: '',
          name: 'wizard-start',
          component: WizardStart,
          meta: {
          },
        },
        {
          path: 'residential',
          name: 'wizard-residential',
          component: WizardResidential,
          meta: {
            category: 'residential',
            pageTitle: 'Residential',
          },
        },
        {
          path: 'business',
          name: 'wizard-business',
          component: () => import('./views/Wizard.Business.vue'),
          meta: {
            category: 'business',
            pageTitle: 'Business',
          },
        },
        {
          path: 'offerings',
          name: 'wizard-offerings',
          component: () => import('./views/Wizard.Offerings.vue'),
          meta: {
            pageTitle: 'Offerings',
          },
        },
      ],
    },

    {
      path: '/service-areas/:id?',
      name: 'service-areas',
      component: () => import('./views/ServiceAreas.vue'),
    },

    {
      path: '/providers',
      component: () => import('./views/Providers.vue'),
      meta: {
        pageTitle: 'Broadband Providers',
      },
      children: [
        {
          path: ':id?',
          name: 'provider-detail',
          component: () => import('./components/Provider.Card'),
          meta: {
            pageTitle: 'Provider Detail',
          },
        },
      ],
    },

    {
      path: '/search-for-service',
      name: 'search-for-service',
      component: () => import('./views/SearchForService.vue'),
    },

    {
      path: '/partners',
      name: 'partners',
      component: () => import('./views/Partners.vue'),
      meta: {
        pageTitle: 'Partners',
      },
      children: [
        {
          path: ':id?',
          name: 'partners-detail',
          component: () => import('./components/Partner.Card'),
          meta: {
            pageTitle: 'Partners',
          },
        },
      ],
    },
  ],

});
